<template>
  <el-drawer
    ref="drawerRef"
    title="FORMULARIO DE COTIZACIÓN"
    size="75%"
    :with-header="true"
    :visible="drawer"
    v-bind="$attrs"
    :before-close="handleClosed"
    @closed="handleClosed"
  >
    <label style="margin: 75px; text-transform: uppercase">{{
      Nº + " - " + infoQuote.clientName
    }}</label>
    <el-form
      :model="ruleForm"
      :rules="rules"
      label-position="top"
      ref="ruleForm"
      class="demo-ruleForm"
    >
      <el-tabs style="padding-left: 5%; padding-right: 5%">
        <el-tab-pane label="GENERAL" name="GENERAL">
          <div
            style="
              justify-content: center;
              display: flex;
              width: 100%;
              font-weight: bold;
            "
          >
            <div style="margin-right: 75px">
              <el-form-item label="Nº">
                <el-input :disabled="Disabled" v-model="Nº"></el-input>
              </el-form-item>

              <el-form-item label="Venta a-Nº Cliente">
                <el-input
                  :disabled="Disabled"
                  v-model="ruleForm.customerCode"
                ></el-input>
              </el-form-item>

              <el-form-item label="Venta a-Nº Contacto">
                <!-- <el-input v-model="infoQuote.contactName"></el-input> -->
                <el-select
                  filterable
                  clearable
                  v-model="ruleForm.contactName"
                  placeholder="Venta a-Nº Contacto"
                >
                  <el-option
                    v-for="(index, key) in contacts"
                    :key="key"
                    :label="index.FullName"
                    :value="index.FullName"
                  ></el-option>
                </el-select>
                <el-button
                  type="primary"
                  @click="createConta"
                  v-if="this.infoQuote.customerCode.includes('CL')"
                  >CREAR CONTACTO</el-button
                >
              </el-form-item>

              <el-form-item label="Venta a-Cód. plant. cliente" prop="Códplant">
                <el-select
                  filterable
                  clearable
                  v-model="ruleForm.Códplant"
                  placeholder="Venta a-Cód. plant. cliente"
                >
                  <el-option label="CONTACINT" value="CONTACINT"></el-option>
                  <el-option label="CONTNAC" value="CONTNAC"></el-option>
                  <el-option
                    :label="ruleForm.customerCode"
                    :value="ruleForm.customerCode"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Venta a-Nombre">
                <el-input
                  :disabled="Disabled"
                  v-model="ruleForm.clientName"
                ></el-input>
              </el-form-item>
            </div>

            <div style="margin-right: 75px">
              <el-form-item label="Venta a-Dirección" prop="address">
                <el-input v-model="ruleForm.address"></el-input>
              </el-form-item>

              <el-form-item label="Venta a-Colonia" prop="address2">
                <el-input v-model="ruleForm.address2"></el-input>
              </el-form-item>

              <el-form-item label="Venta a-Municipio/Ciudad">
                <el-select
                  filterable
                  clearable
                  v-model="ruleForm.city"
                  placeholder="Venta a-Municipio/Ciudad"
                  @change="changed"
                >
                  <el-option
                    v-for="(index, key) in towns2"
                    :key="key"
                    :label="index.City"
                    :value="index"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Venta a-Estado/ C.P">
                <el-input v-model="ruleForm.state"></el-input>
              </el-form-item>

              <el-form-item label="Venta a-C.P" prop="statusCP">
                <el-input v-model="ruleForm.statusCP"></el-input>
              </el-form-item>
            </div>

            <div style="margin-right: 75px">
              <el-form-item label="Fecha pedido" required>
                <el-col :span="23">
                  <el-form-item prop="dateP">
                    <el-date-picker
                      type="date"
                      placeholder="Ingrese la fecha"
                      v-model="ruleForm.dateP"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>

              <el-form-item label="Fecha emisión documento" required>
                <el-col :span="23">
                  <el-form-item prop="dateEM">
                    <el-date-picker
                      type="date"
                      placeholder="Ingrese la fecha"
                      v-model="ruleForm.dateEM"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>

              <el-form-item label="Fecha de entrega requeridad" required>
                <el-col :span="23">
                  <el-form-item prop="dateE">
                    <el-date-picker
                      type="date"
                      placeholder="Ingrese la fecha"
                      v-model="ruleForm.dateE"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>

              <el-form-item label="Cód. vendedor">
                <div style="display: flex">
                  <input
                    v-if="infoQuote.sellerImage"
                    type="image"
                    :src="infoQuote.sellerImage"
                    class="image_seller"
                  />
                  <el-input :disabled="Disabled" v-model="infoQuote.sellerName">
                  </el-input>
                  <!-- <el-avatar :size="50" :src="sellerImage"> </el-avatar> -->
                </div>
              </el-form-item>

              <el-form-item label="Estado" prop="status">
                <el-select
                  filterable
                  clearable
                  v-model="ruleForm.status"
                  placeholder="Estado"
                >
                  <el-option label="Abierto" value="0"></el-option>
                  <el-option label="Cerrado" value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="FACTURACIÓN" name="FACTURACIÓN">
          <div
            style="
              justify-content: center;
              display: flex;
              width: 100%;
              font-weight: bold;
            "
          >
            <div style="margin-right: 75px">
              <el-form-item label="Método de pago" prop="methodPayment">
                <el-select
                  filterable
                  clearable
                  v-model="ruleForm.methodPayment"
                  placeholder="Método de pago"
                >
                  <el-option label="BANCO" value="BANCO"></el-option>
                  <el-option label="CHEQUE" value="CHEQUE"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Precio Total">
                <el-input-number
                  controls-position="right"
                  :min="1"
                  disabled
                  v-model="ruleForm.priceTotal"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="Precio Unitario">
                <el-input-number
                  controls-position="right"
                  :min="1"
                  v-model="ruleForm.unitPrice"
                ></el-input-number>
              </el-form-item>
            </div>

            <div style="margin-right: 75px">
              <el-form-item label="Cantidad de producto">
                <el-input-number
                  controls-position="right"
                  :min="1"
                  v-model="ruleForm.quantity"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="Descuento">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  v-model="ruleForm.discount"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="Condiciones de Pago:">
                <el-input v-model="ruleForm.paymentCondition"></el-input>
              </el-form-item>
            </div>

            <div style="margin-right: 75px">
              <el-form-item label="Código divisa" prop="codDivisa">
                <el-select
                  filterable
                  clearable
                  v-model="ruleForm.codDivisa"
                  placeholder="Código divisa"
                >
                  <el-option label="USD" value="USD"></el-option>
                  <el-option label="RD" value="RD"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="RNC/Cédula">
                <el-input v-model="ruleForm.RNC_Cedula"></el-input>
              </el-form-item>

              <el-form-item label="Precio de instalación">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  v-model="ruleForm.priceInstalacion"
                ></el-input-number>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="ENVÍO" name="ENVÍO">
          <div
            style="
              justify-content: center;
              display: flex;
              width: 100%;
              font-weight: bold;
            "
          >
            <div style="margin-right: 75px" v-if="infoQuote.customerEmail">
              <el-form-item label="Email del cliente">
                <el-input v-model="ruleForm.customerEmail"></el-input>
              </el-form-item>
            </div>
            <div style="margin-right: 75px" v-if="infoQuote.contactEmail">
              <el-form-item label="Email del contacto">
                <el-input v-model="ruleForm.contactEmail"></el-input>
              </el-form-item>
            </div>
            <div style="margin-right: 75px">
              <el-form-item label="Teléfono">
                <el-input v-model="ruleForm.phone"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane
          label="COMERCIO EXTERIOR"
          name="COMERCIO EXTERIOR"
          :disabled="Disabled"
        >
          <h1>EN CONSTRUCCIÓN</h1>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <div style="margin-left: 40%; margin-top: 2%">
      <el-button type="primary" @click="submitForm('ruleForm')"
        >REALIZAR COTIZACIÓN</el-button
      >
      <el-button type="d" @click="resetForm('ruleForm')">CANCELAR</el-button>
    </div>

    <div style="margin: 5%">
      <el-button type="primary" icon="el-icon-download" @click="downloadPDF"
        >DESCARGAR PDF</el-button
      >
      <iframe
        style="margin-top: 1%"
        id="frameQuote"
        src=""
        frameborder="0"
      ></iframe>
    </div>

    <!-- <DealsTableQuote :loading="loading" ref="tableQuote" /> -->
    <ContactFormQ
      ref="contact"
      :CustomerCode="this.infoQuote.customerCode"
      :drawer.sync="drawerContact"
      @created="getContactByCostumer"
    />
  </el-drawer>
</template>

<script>
// import { formatDate } from "@/utils";
import { formatMonto } from "@/utils";
import columnsQuote from "@/components/deals/columnsQuote.js";
import ContactFormQ from "@/components/deals/ContactFormQ.vue";
import town from "@/helpers/town(municipios).js";
import generatePDFQuote from "@/components/deals/generatePDFQuote.js";
// import DealsTableQuote from "@/components/deals/DealsTableQuote.vue";
// import ContactFrom from "../contacts/ContactForm";

export default {
  formatMonto,
  generatePDFQuote,
  town,
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    infoQuote: {
      type: Object,
      default: function () {
        return {};
      }
    },
    dataNextPhase: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  components: {
    // DealsTableQuote,
    // ContactFrom,
    ContactFormQ
  },
  data() {
    return {
      numDeal: [],
      data2: {},
      drawerContact: false,
      Nº: 0,
      Disabled: true,
      contacts: [],
      dataQuote: [],
      loading: false,
      search: "",
      price: "",
      actions: [
        {
          icon: "el-icon-edit",
          label: "Actualizar",
          command: "update-command"
        }
      ],
      COLUMNS: columnsQuote,
      ruleForm: {
        Códplant: "CONTNAC",
        state: "",
        dateP: new Date(),
        dateD: new Date(),
        dateEM: new Date(),
        dateE: new Date(),
        NºCam: "",
        status: "Abierto",
        statusCP: "",
        countryRCODE: "",
        Antención: "",
        cResponsabilidad: "",
        idUsuarioAS: "",
        methodPayment: "BANCO",
        price: 0,
        discount: 0,
        codDivisa: "USD",
        priceTotal: 0,
        paymentCondition: "",
        priceInstalacion: 0,
        sellerName: "",
        venClient: "",
        contactName: "",
        clientName: "",
        address: "",
        address2: "",
        city: "",
        unitPrice: "",
        quantity: "",
        RNC_Cedula: "",
        productName: "",
        customerEmail: "",
        contactEmail: "",
        phone: ""
      },
      towns: town,
      towns2: [],
      rules: {
        Códplant: [
          {
            required: true,
            message: "Debes de ingresar el código",
            trigger: "change"
          }
        ],
        dateP: [
          {
            type: "date",
            required: true,
            message: "Debes de ingresar la fecha de Pedido",
            trigger: "change"
          }
        ],
        dateD: [
          {
            type: "date",
            required: true,
            message: "Debes de ingresar la Fecha emisión documento",
            trigger: "change"
          }
        ],
        dateEM: [
          {
            type: "date",
            required: true,
            message: "Debes de ingresar la Fecha emisión documento",
            trigger: "change"
          }
        ],
        dateE: [
          {
            type: "date",
            required: true,
            message: "Debes de ingresar la Fecha de entrega requeridad",
            trigger: "change"
          }
        ],
        NºCam: [
          {
            required: true,
            message: "Debes de ingresar el Nº de campaña",
            trigger: "change"
          }
        ],
        status: [
          {
            required: true,
            message: "Debes de ingresar el Estado",
            trigger: "change"
          }
        ],
        statusCP: [
          {
            required: true,
            message: "Debes de ingresar el C.P",
            trigger: "change"
          }
        ],
        Antención: [
          {
            required: true,
            message: "Debes de ingresar la antención",
            trigger: "change"
          }
        ],
        cResponsabilidad: [
          {
            required: true,
            message: "Debes de ingresar el centro de responsabilidad",
            trigger: "change"
          }
        ],
        idUsuarioAS: [
          {
            required: true,
            message: "Debes de ingresar el Id del usuario asignado",
            trigger: "change"
          }
        ],
        methodPayment: [
          {
            required: true,
            message: "Debes de ingresar el Método de pago",
            trigger: "change"
          }
        ],
        price: [
          {
            required: true,
            message: "Debes de ingresar el Método de pago",
            trigger: "change"
          }
        ],
        codDivisa: [
          {
            required: true,
            message: "Debes de ingresar el Código divisa",
            trigger: "change"
          }
        ],

        address: [
          {
            required: true,
            message: "Debes de ingresar la dirección",
            trigger: "change"
          },
          {
            min: 3,
            max: 49,
            message: "Solo se permiten carácteres de 3 a 50",
            trigger: "blur"
          }
        ],
        address2: [
          {
            required: true,
            message: "Debes de ingresar la dirección",
            trigger: "change"
          },
          {
            min: 3,
            max: 49,
            message: "Solo se permiten carácteres de 3 a 50",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.$message.success("submit!");
          this.loading = true;
          this.$confirm("Segura/o que desea cambiar de fase este registro ?")
            .then(() => {
              this.$http
                .get("/api/deals/formQuote", {
                  params: {
                    DocumentType: 0,
                    CustomerCode: this.infoQuote.customerCode,
                    CustomerName: this.infoQuote.clientName,
                    SellerId: this.infoQuote.sellerId,
                    Street: this.infoQuote.address,
                    Street2: this.infoQuote.address2,
                    City: this.infoQuote.city,
                    CustomerContactName: this.infoQuote.contactName,
                    OrderDate: this.dateFormatter(),
                    QuoteNumber: this.Nº,
                    Payment: this.infoQuote.totalAmount,
                    PaymentMethod: this.ruleForm.methodPayment,
                    CodDiscInvoice: this.ruleForm.Códplant,
                    CodPost: this.ruleForm.statusCP,
                    CountryRegionCode: this.ruleForm.countryRCODE,
                    Status: this.ruleForm.status,
                    CodDivisa: this.ruleForm.codDivisa,
                    RNC_Cedula: this.infoQuote.RNC_Cedula,
                    AccountReceivableExec: this.infoQuote.accountReceivableExec,
                    CustomerServiceExec: this.infoQuote.customerServiceExec
                  },
                  timeout: 3 * 60 * 100
                })
                .then((resp) => {
                  if (resp.data.length > 0) {
                    // this.$refs.tableQuote.SelectformQuote();
                    this.$message.success("Cotización realizada exitosamente.");
                    this.$http
                      .post("/api/deals/ChangePhase", this.dataNextPhase)
                      .then(({ data }) => {
                        this.$store.commit("setSplashScreen", false);
                        this.$store.commit("deals/MOVE_DEAL", {
                          from: data.From,
                          to: data.To,
                          deal: data.Deal
                        });
                        this.$message.success("Etapa cambiada, exitosamente.");
                        this.drawer = false;
                      })
                      .catch((error) => {
                        console.error(error);
                        this.$message.error("Error al cambiar la etapa.");
                      });

                    this.loading = false;
                  } else {
                    this.$message.error("Error al cargar datos fffff");
                  }
                })
                .catch((error) => {
                  this.$message.error(
                    "No se pudo realizar la cotización",
                    error
                  );
                  // this.$refs.tableQuote.SelectformQuote();
                  this.loading = false;
                });
            })
            .catch(() => {});
        } else {
          this.$message.error(
            "Campos incorrectors, por favor de revisar si faltan campos obligatorios por llenar o si no pasan el límite"
          );
          return false;
        }
      });
    },
    getLastN() {
      this.$http
        .get("/api/deals/formQuote", {
          params: {
            Option: "S"
          },
          timeout: 3 * 60 * 100
        })
        .then((resp) => {
          if (resp.data) {
            this.Nº = parseInt(resp.data[0].No_) + 1 + "-MNF";
          } else {
            this.$message.error("Error al cargar datos");
          }
        })
        .catch((error) => {
          this.$message.error("Error al cargar datos", error);
        });
      this.SelectformQuote();
    },
    SelectformQuote() {
      this.$http
        .get("/api/deals/SelectformQuote", {
          timeout: 3 * 60 * 100
        })
        .then((resp) => {
          if (resp.data) {
            this.dataQuote = resp.data;
          } else {
            this.$message.error("Error al cargar datos");
          }
        })
        .catch((error) => {
          this.$message.error("Error al cargar datos", error);
        });
    },
    dateFormatter() {
      let date = this.ruleForm.dateP.toJSON();
      return (date = date.substr(0, date - 14) + " 00:00:00.000");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("close-drawer");
    },
    handleClosed() {
      this.$emit("close-drawer");
      this.$refs.tableQuote.SelectformQuote();
      this.numDeal = [];
    },
    getContactByCostumer() {
      // this.infoQuote.contactName = "";
      // esto es para válidar si es un cliente
      if (this.infoQuote.customerCode.includes("CL")) {
        this.$http
          .get("/api/contacts/GetContactByCustomerCode", {
            params: {
              customerCode: this.infoQuote.customerCode,
              companyCode: this.currentCompany
            }
          })
          .then(({ data }) => {
            this.contacts = data;
            // this.infoQuote.contactName = data[0].FullName;
          })
          .catch((err) => {
            this.$message.error(
              `no se pudieron tener contacto sobre este cliente ${err}`
            );
          })
          .finally(() => {
            this.loadingContacts = false;
          });
      } else
        this.$http
          .get("/api/contacts/GetContactByProspect", {
            params: {
              contactCode: this.infoQuote.customerCode,
              companyCode: this.currentCompany
            }
          })
          .then(({ data }) => {
            this.contacts = data;
            // this.infoQuote.contactName = data[0].FullName;
          })
          .catch((err) => {
            this.$message.error(
              `no se pudieron tener contacto sobre este cliente ${err}`
            );
          })
          .finally(() => {
            this.loadingContacts = false;
          });
    },
    SelectPostCode() {
      this.$http
        .get("/api/deals/SelectPostCode")
        .then(({ data }) => {
          this.towns2 = data;

          /*esto es para obtener el primer municipio del array
          que coincida con el nombre
          del municipio que le paso por parametro*/
          const result = this.towns2.find(
            (element) => (element.City = this.infoQuote.city.toUpperCase())
            // element.City.includes(this.infoQuote.city.toUpperCase())
          );
          this.ruleForm.city = this.infoQuote.city;
          this.ruleForm.state = result.County;
          this.ruleForm.statusCP = result.Code;
          this.ruleForm.countryRCODE = result.Country_Region_Code;
        })
        .catch((err) => {
          this.$message.error(`no se pudieron tener los detalles ${err}`);
        })
        .finally(() => {
          this.loadingContacts = false;
        });
    },
    changed(v) {
      // console.log("changed", v.Municipio);
      // this.ruleForm.state = v.Código.substring(0, v.Código.length - 1);
      this.ruleForm.city = v.City;
      this.ruleForm.state = v.County ? v.County : "  ";
      this.ruleForm.statusCP = v.Code ? v.Code : "  ";
      this.ruleForm.countryRCODE = v.Country_Region_Code
        ? v.Country_Region_Code
        : "  ";
    },
    createConta() {
      this.drawerContact = true;
    },
    downloadPDF() {
      generatePDFQuote(this.ruleForm, this.data2, true);
    }
  },
  watch: {
    infoQuote: {
      handler: function () {
        this.SelectPostCode();

        this.ruleForm.sellerName = this.infoQuote.sellerName;
        this.ruleForm.customerCode = this.infoQuote.customerCode;
        this.ruleForm.contactName = this.infoQuote.contactName;
        this.ruleForm.clientName = this.infoQuote.clientName;
        this.ruleForm.address = this.infoQuote.address;
        this.ruleForm.address2 = this.this.infoQuote.address2;
        // this.getLastN();
        // this.data2 = {
        //   priceTotal: this.ruleForm.priceTotal,
        //   fechaEmi: new Date().toLocaleDateString(),
        //   numQuote: this.Nº,
        //   discount: this.ruleForm.discount,
        //   paymentCondition: this.ruleForm.paymentCondition,
        //   priceInstalacion: this.ruleForm.priceInstalacion
        // };
        // generatePDFQuote(this.infoQuote, this.data2, false);
      },
      deep: true
    },
    ruleForm: {
      handler: function () {
        this.getLastN();
        this.getContactByCostumer();

        this.ruleForm.unitPrice = this.infoQuote.unitPrice;
        this.ruleForm.quantity = this.infoQuote.quantity;
        this.ruleForm.RNC_Cedula = this.infoQuote.RNC_Cedula;
        this.ruleForm.productName = this.infoQuote.productName;
        this.ruleForm.customerEmail = this.infoQuote.customerEmail;
        this.ruleForm.contactEmail = this.infoQuote.contactEmail;
        this.ruleForm.phone = this.infoQuote.phone;

        this.ruleForm.priceTotal =
          this.ruleForm.unitPrice * this.ruleForm.quantity;

        this.data2 = {
          priceTotal: this.ruleForm.priceTotal,
          fechaEmi: new Date().toLocaleDateString(),
          numQuote: this.Nº,
          discount: this.ruleForm.discount,
          paymentCondition: this.ruleForm.paymentCondition,
          priceInstalacion: this.ruleForm.priceInstalacion
        };
        generatePDFQuote(this.ruleForm, this.data2, false);
      },
      deep: true
    }
  }
};
</script>
<style>
body.theme-tb .el-button--d:hover,
body.theme-tb .el-button--d:focus {
  background-color: red;
  border-color: red;
  color: #fff;
}
input.image_seller {
  width: 40px;
  height: 40px;
  border: 0px;
  position: relative;
  top: 1px;
}
.el-drawer__body .el-input__inner {
  text-transform: uppercase;
}
#frameQuote {
  width: 100%;
  min-height: 1250px;
  height: 100%;
  max-height: 1500px;
}
</style>
